/**
 * Win/Draw/Loss yardımcıları.
 * cp -> kazanma olasılığı dönüşümü Stockfish "win rate model" yaklaşımıdır.
 * Not: chess.com'un gerçek doğruluk formülü kapalıdır; buradaki değerler
 * yaygın kabul gören (Lichess benzeri) yaklaşıklardır.
 */

const WP_COEFF = 0.00368208;

/** cp (0.01 piyon) -> kazanma olasılığı (0..1), side-to-move POV. */
export function cpToWinProb(cp: number): number {
  const c = Math.max(-1500, Math.min(1500, cp));
  return 1 / (1 + Math.exp(-WP_COEFF * c));
}

/** Mat uzaklığı (işaretli) -> kazanma olasılığı. */
export function mateToWinProb(mate: number): number {
  const steps = Math.min(Math.abs(mate), 250);
  return mate > 0 ? 1 - steps * 0.004 : steps * 0.004;
}

/** Win-prob -> eşdeğer cp (evaluation bar ve kayıp ölçümü için ters dönüşüm). */
export function winProbToCp(wp: number): number {
  const c = Math.max(0.001, Math.min(0.999, wp));
  return Math.max(-1400, Math.min(1400, Math.log(c / (1 - c)) / WP_COEFF));
}

/** cp-kaybından hamle doğruluğu (0-100). Lichess doğruluk formülü. */
export function cpLossToAccuracy(cpLoss: number): number {
  const acc = 103.1668 * Math.exp(-0.04354 * Math.max(0, cpLoss)) - 3.1669;
  return Math.max(0, Math.min(100, acc));
}
